import React from "react";
import HomeIcon from "@mui/icons-material/Home";

function GddHomeIcon({ iconColor, iconSize = "small", ...other }) {
    return <HomeIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default GddHomeIcon;
